import $ from 'jquery';
import View from 'mixins/view';
import CommentsService from '@ui/comments/CommentService';
import ShoutboxPaginator from '@ui/shoutbox/paginator';

export const elements = {
    container: '.c-comments-main-filters',
    label: '.c-comments-main-filters__label',
    base: '.comments-list__base',
    timesContainer: '.c-comments-main-filters-times',
    times: '.c-comments-main-filters-times a',
    liveBanner: ".c-comments__new-link.c-comments__new-link--base",
};

export const updateLabels = (news) => {
    const commentsLength = CommentsService
      .getVisibleCommentsCollection()
      .get('comments').length;
    const filter = CommentsService.getVisibleCommentsCollection()
      .get('filter');

    if (commentsLength) {
      $(elements.container).removeClass('collapsed');
    }
    const recommended = CommentsService
      .getVisibleCommentsCollection()
      .get('recommendedCount');
    const recommendedTemplate = (recommended)
        ? `<i class="icon-star-size_2-color_apporange shift-margin_1-right"></i> Polecane (${recommended})`
        : '<i class="icon-star-size_2-color_apporange shift-margin_1-right"></i> Polecane';
    const newsTemplate = (news && filter !== 'date')
        ? `Najnowsze (${news})`
        : `Najnowsze`;

    $(`${elements.label}[data-criterion=date]`).html(newsTemplate);
    $(`${elements.label}[data-criterion=recommended]`).html(recommendedTemplate);
};

export const setLabel = function (criterion) {
    CommentsService
      .getVisibleCommentsCollection()
      .set('filter', criterion);
    $(elements.container).removeClass('collapsed');
    $(elements.label).removeClass('fn-active');
    $(`${elements.label}[data-criterion='${criterion}']`).addClass('fn-active');
};

export const setSinceFilter = function (criterion, since) {
    $(elements.container).removeClass('collapsed');

    if (criterion === 'date') {
        const $active = $(`${elements.times}[data-since='${since}']`);
        $(elements.times).removeClass('fn-active');
        $active.addClass('fn-active');
        $(elements.timesContainer).removeClass('fn-hidden');
    } else {
        $(elements.timesContainer).addClass('fn-hidden');
    }
};

export const init = (params) => {
    const commentsCollection = CommentsService
      .getVisibleCommentsCollection();

    document.addEventListener('RefreshOnBufferedLiveComments', (event) => {
      updateLabels(event.detail.base);
    });
    document.addEventListener('ClearFiltersNewCount', () => {
      updateLabels();
    });
    document.addEventListener('CommentsInitialised', () => {
      updateLabels();
    });
    document.addEventListener('AddBaseCommentSuccess', () => {
      updateLabels(1);
    });
    document.addEventListener('ChangeCommentFilter', (option) => {
      setLabel(option.detail);
      updateLabels();
    });

    params.$document.on('click', (elements.label + ', ' + elements.times), function(event) {

        event.preventDefault();

        $(elements.base).addClass('comments-list--loading');

        const criterion = $(this).data('criterion');
        setLabel(criterion);

        if (CommentsService.isShoutboxMode()) {

          const type = (criterion == 'date') ? 'latest' : 'best';
          let since = $(this).data('since');
          let filters = { type: type, page: 1 };

          if (since) {
              const params = CommentsService.getShoutboxParams();
              since = (params.since === since) ? false : since;
              filters.since = since;
          } else {
              since = false;
              filters.since = since;
          }

          setSinceFilter(criterion, since);
          CommentsService.setShoutboxParams(filters);
        }

        CommentsService.updateCollection(function(data) {
            $(elements.liveBanner).addClass('hide');

            /**
             * @TODO
             * verify shoutbox paginator render
             */
        });
    });

    const commentsLength = CommentsService
      .getVisibleCommentsCollection()
      .get('comments').length;

    if (!commentsLength) {
      $(elements.container).addClass('collapsed');
    }
};

class CommentsFilterView extends View {
  constructor(model) {
    super(model);
    this.setRootEl($(elements.container));
  }
  render() {
    this.moderationLabel = this.rootEl.find('fieldset.moderation-mode');
  }
  toggleModerationMode() {
    const isModerationActive = this.moderationLabel.hasClass('fn-active');
    const input = this.moderationLabel.find('input');

    input.prop('checked', true);
    this.moderationLabel.addClass('fn-active');

    if (isModerationActive) {
      input.prop('checked', false);
      this.moderationLabel.removeClass('fn-active');
    }
    return !isModerationActive;
  }
  getModerationLabel() {
    return this.moderationLabel;
  }
}

export default {init, CommentsFilterView};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/filters.js